var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-7 pa-5"},[_c('CreateAppClient'),_c('ListAppClient',{attrs:{"listAppData":_vm.listAppData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }